import { Outlet, useParams } from 'react-router-dom'

import { PlanningPeriodDetailDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const PeriodDetailPage = () => {
  const { periodId } = useParams<{ periodId: string }>()

  const { data, loading, error } = useQuery(PlanningPeriodDetailDocument, {
    variables: { id: periodId ?? '' },
    skip: !periodId,
  })

  const period = data?.planning?.period

  return (
    <ResponsivePage.Body
      variant="full"
      onActionClick={() => {}}
      loading={loading}
      error={error}
      authorized={!!period}
    >
      <Outlet context={{ period, periodId }} />
    </ResponsivePage.Body>
  )
}

export default PeriodDetailPage
